import SvgIcon from "@mui/material/SvgIcon";
import React, { PropsWithChildren } from "react";

const CommonIcon: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 -960 960 960"
        xmlns="http://www.w3.org/2000/svg"
      >
        {children}
      </svg>
    </SvgIcon>
  );
};

export default CommonIcon;
